import { generateId } from '@freelancer/datastore/testing/helpers';
import { ReferralRecordStatusApi } from 'api-typings/common/common';
import type { ReferralRecord } from './referral-records.model';

export interface GenerateReferralRecordOptions {
  readonly id?: string;
  readonly username?: string;
  readonly email?: string;
  readonly status?: ReferralRecordStatusApi;
  readonly timeSent?: number;
}

export function generateReferralRecords(
  referralInvitationOptions: readonly GenerateReferralRecordOptions[],
): readonly ReferralRecord[] {
  return referralInvitationOptions.map(referralProfileOption =>
    generateReferralRecordObject(referralProfileOption),
  );
}

export function generateReferralRecordObject({
  id = String(generateId()),
  username = '',
  email = `test${id}@test.com`,
  status = ReferralRecordStatusApi.PENDING,
  timeSent = 0,
}: GenerateReferralRecordOptions): ReferralRecord {
  return {
    id,
    displayName: username || email,
    username,
    email,
    status,
    timeSent,
  };
}
